<template>
  <v-ons-list
    class="destination-lists"
    modifier="noborder"
  >
    <person-outline
      v-for="destination in destinations"
      :key="destination.id + destination.type"
      :thing="destination"
      tappable
    />
  </v-ons-list>
</template>

<script>
import personOutline from '@/components/map/partials/destination_outline/person.vue';

export default {
  components: {
    personOutline,
  },
  computed: {
    destinations: ({ $store }) => $store.state.searchResult.destinations,
  },
};
</script>



// WEBPACK FOOTER //
// list.vue?e945eff2